var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3188_78356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 20.7716C6.70772 20.8402 7.32497 20.7841 7.90627 20.6074C8.48758 20.4307 9.01828 20.1377 9.45961 19.75C9.77793 20.0716 10.1667 20.3287 10.6008 20.5047C11.0349 20.6806 11.5046 20.7715 11.9796 20.7715C12.4546 20.7715 12.9244 20.6806 13.3584 20.5047C13.7925 20.3287 14.1813 20.0716 14.4996 19.75C14.8179 20.0716 15.2067 20.3287 15.6408 20.5047C16.0749 20.6806 16.5446 20.7715 17.0196 20.7715C17.4946 20.7715 17.9644 20.6806 18.3984 20.5047C18.8325 20.3287 19.2213 20.0716 19.5396 19.75C19.9809 20.1377 20.5116 20.4307 21.0929 20.6074C21.6743 20.7841 22.2915 20.8402 22.8996 20.7716",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.375 4.65625H6.625C5.90013 4.65625 5.3125 5.24388 5.3125 5.96875V23.0312C5.3125 23.7561 5.90013 24.3438 6.625 24.3438H22.375C23.0999 24.3438 23.6875 23.7561 23.6875 23.0312V5.96875C23.6875 5.24388 23.0999 4.65625 22.375 4.65625Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.28125H9.25C8.52513 7.28125 7.9375 7.86888 7.9375 8.59375V9.90625C7.9375 10.6311 8.52513 11.2187 9.25 11.2187H11.875C12.5999 11.2187 13.1875 10.6311 13.1875 9.90625V8.59375C13.1875 7.86888 12.5999 7.28125 11.875 7.28125Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 7.28125H17.125C16.4001 7.28125 15.8125 7.86888 15.8125 8.59375V9.90625C15.8125 10.6311 16.4001 11.2187 17.125 11.2187H19.75C20.4749 11.2187 21.0625 10.6311 21.0625 9.90625V8.59375C21.0625 7.86888 20.4749 7.28125 19.75 7.28125Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 11.2188H23.6875",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 15.1562H23.6875",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3188_78356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBed);
export default __webpack_public_path__ + "static/media/water_bed.a37f7a57.svg";
export { ForwardRef as ReactComponent };